import styled from 'styled-components';

export const StyledImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  img {
    width: 100%;
    max-height: 480px;
    object-fit: cover;
    visibility: hidden;
  }
`;

export const StyledMedia = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
`;
